import cn from 'classnames';
import PropTypes from 'prop-types';

import { ADD_BILL_ADDRESS, EDIT_BILL_ADDRESS } from 'constants/checkoutButtons';
import { CHECKOUT_STEP_MAP, SELECT_BILLING_ADDRESS_STEP } from 'constants/checkoutFlow';

import AddressForm from 'components/checkout/caap/address/AddressForm';
import BackButton from 'components/checkout/caap/BackButton';
import ModalOverlay from 'components/checkout/caap/ModalOverlay';
import {
  closeButton,
  contentWrapper,
  modalTitleContainer,
  newAddressContainer,
  showOnlySmallScreen,
  titleWhenBackBtn
} from 'styles/components/checkout/caap/address/newAddressModal.scss';
import css from 'styles/components/checkout/caap/address/newBillingAddressModal.scss';

const NewBillingAddressModal = (componentParams, { testId }) => {
  const {
    address,
    isFetchingCheckoutData,
    onAddressFieldChange,
    onCloseModalOverlayClick,
    onCountryDropdownChange,
    onUseBillingAddressClick,
    pageHistory,
    showAsModal
  } = componentParams;

  const useThisAddressButtonId = address.addressId ? EDIT_BILL_ADDRESS : ADD_BILL_ADDRESS;
  const sectionTitleStyles = cn({ [titleWhenBackBtn]: pageHistory && pageHistory.includes('address') });

  return (
    <div className={newAddressContainer}>
      <ModalOverlay onCloseModalOverlayClick={onCloseModalOverlayClick} showAsModal={showAsModal}>
        {
          showAsModal
            ? <div className={`${modalTitleContainer} ${css.hideSmallScreen}`}>
              { address.addressId ? 'Edit billing address' : 'Add a billing address' }
              <button
                type="button"
                className={closeButton}
                data-test-id={testId('closeModal')}
                onClick={onCloseModalOverlayClick}
                onKeyPress={onCloseModalOverlayClick}
                role="link"
                tabIndex="0"
                title="Close Modal"></button>
            </div>
            : null
        }

        {
          pageHistory && pageHistory.includes('address')
            ? <BackButton href={CHECKOUT_STEP_MAP[SELECT_BILLING_ADDRESS_STEP]} />
            : null
        }

        <div className={showOnlySmallScreen}><h1 className={sectionTitleStyles}>Enter billing address</h1></div>

        <form method="post" onSubmit={onUseBillingAddressClick}>
          <div className={contentWrapper}>
            <AddressForm
              address={address}
              isBilling={true}
              onCountryDropdownChange={onCountryDropdownChange}
              onFieldChange={onAddressFieldChange}
            />
          </div>

          <div className={css.continueButtonContainer}>
            <button
              className={css.checkoutPrimaryButton}
              id={useThisAddressButtonId}
              disabled={isFetchingCheckoutData}
              onClick={onUseBillingAddressClick}
              type="submit">
              Use this address
            </button>
          </div>

        </form>
      </ModalOverlay>
    </div>
  );
};

NewBillingAddressModal.contextTypes = {
  testId: PropTypes.func
};

export default NewBillingAddressModal;
